import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import chroma from 'chroma-js'
import { Doughnut,Bar} from 'react-chartjs'
import { Row, Col} from 'react-flexbox-grid'
import ReactTooltip from 'react-tooltip'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  FundMenu,
  FundName,
  FundShareTakeAction,
  InlineSignup,
  IyvScorecard,
  // AssetManagerLetter
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundCleanEnergyInvestments.css'

const FirstPage = 5
const AllPage = 1000000

const ScaleStart = '#00a6d0'
const ScaleEnd = '#00a6d0'

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{ return fHoldingsMap[o.id].market_value * -1 })
  // .take(10)
  .value()
}

const pieChartOptions = {
  animation: false,
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  // animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  // tooltipTemplate: "<%if (label){%><%=label %>: $<%}%><%= value + ' M' %>",
  tooltipTemplate: '<%=label %>',
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>",
}

const barChartOptions = {
  animation: false,
  responsive: true,
  scaleShowLabels: true,
  scaleShowGridLines: true,
  scaleShowVerticalLines: false,
  scaleShowHorizontalLines: true,
  showScale: true,
  scaleStartValue: 0,
  // String - Template string for single tooltips
  tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>",
}

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId,
                                                    params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundCleanEnergyInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      clean200Page: 1
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    analytics.event(analytics.eventLoadFund(this.props.params.fundId,
                                            this.props.params.investmentVehicleId))
  }

  getPieChartData = (invested, fHoldingsMap, holdings) => {
    // if no holdings, return data for a plain gray donut
    if (holdings.length === 0) {
      return [{
        value: 1,
        label: 'No Clean200 Stock Holdings',
        color: '#D5D5D5'
      }]
    }

    // build a color scale based on how many holdings there are
    const num_colors = holdings.length
    const f = chroma.scale([ScaleStart, ScaleEnd])
                    .mode('rgb').colors(num_colors)
    let currIdx = -1

    // format holdings as pie chart data
    const pieChartHoldings =  holdings.map((holding) => {
      const nameLabel = format.longString(holding.security_name, 15)
      const moneyLabel = format.money(fHoldingsMap[holding.id].market_value,
                                      true, 'USD', true)
      // increment the counter for the color index
      currIdx = (currIdx + 1) % num_colors

      return {
        value: fHoldingsMap[holding.id].market_value,
        label: nameLabel + ' ' + moneyLabel,
        color: f[currIdx]
      }
    })

    return pieChartHoldings
  }

  getBarChartData = (clean200, fossil) => {
    const solids = ['#00a6d0', '#333333']

    return {
      labels: [
        'Clean200',
        'Carbon Underground 200'
      ],
      datasets: [
        {
          label: 'Amount invested',
          fillColor : solids,
          strokeColor : solids,
          highlightFill: solids,
          highlightStroke: solids,
          data: [
            clean200,
            fossil
          ]
        }
      ]
    }
  }

  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) =>{
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState( newState )
    }
  }

  holdingsCount = ( count ) => {
    if (count === 1) {
      return format.number(count) + ' holding'
    } else if (count > 0) {
      return format.number(count) + ' holdings'
    }
    return ''
  }

  renderHoldings = ( shareClass, fHoldingsMap, holdings, page ) => {
    if( !holdings || holdings.length === 0 ){
      return (
        <div styleName='holdings-none'>None</div>
      )
    }

    const takeCount = (page > 1) ? AllPage : FirstPage

    return chain(holdings)
    .take(takeCount)
      .map( (h,idx) =>{
        return (
          <li key={idx} styleName='holding'>
            <div styleName='holding-name'>
              <div>
                {idx+1}. {h.security_name}
              </div>
            </div>
            <div styleName='holding-asset'>
              {format.sectorLabel(h.sector)}
            </div>
            <div styleName='holding-asset'>
              {format.perc(fHoldingsMap[h.id].long_weight)} of assets
            </div>
            <div styleName='holding-invested'>
              { format.money(fHoldingsMap[h.id].market_value, true, shareClass.currency, true)} invested
            </div>
          </li>
        )
      })
      .value()
  }

  renderCompanies = ( shareClass,fHoldingsMap,type, label, _count, holdings, page ) => {
    const iconClean200Inactive = require( '../../../static/images/clean-200-icon-inactive.png' )
    const iconClean200 = require( '../../../static/images/clean-200-icon.png' )

    const count = convert.int(_count)

    const hasMoreButton = ((page === 1) && (count > FirstPage)) ?
      ( <div styleName={'detail-more-'+type}
       onClick={this.increment(type+'Page')}>See all</div> ) : null

    if (count === 0) {
      return (
        <Col xs={12} styleName='detail-holdings-wrapper'>
          <div styleName={'detail-wrapper-empty-clean'}>
            <img styleName='detail-icon-empty' src={iconClean200Inactive}
              alt='0 holdings' />
            <div styleName='detail-title-empty'>{label}</div>
            <div styleName='detail-holdings-empty'>0 holdings</div>
          </div>
        </Col>
      )
    }

    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName={'detail-'+type}>
          <img styleName={'detail-icon'} src={iconClean200} alt={label} />
          <div styleName='detail-title-holdings'>
            <div styleName={'detail-title-'+type}>{label}</div>
            <div styleName={'visible-sm visible-md visible-lg detail-holdings-count-'+type}>
              { this.holdingsCount(count) }
            </div>
          </div>
          <div styleName={'visible-xs mobile-holdings-label'}>
            { this.holdingsCount(count) }
          </div>
          <ul styleName='detail-holdings'>
            { this.renderHoldings(shareClass, fHoldingsMap, holdings, page) }
          </ul>
        </div>
        { hasMoreButton }
      </Col>
    )
  }

  renderMoreLessHeadline = (cl_asset, c2asset) => {
    let cl_fossil_more_less = ''
    if (cl_asset > c2asset) {
      cl_fossil_more_less = 'more'
    } else if (cl_asset < c2asset) {
      cl_fossil_more_less = 'less'
    } else if (cl_asset === c2asset) {
      cl_fossil_more_less = 'same'
    }

    let line = ''
    if (cl_fossil_more_less==='more'){
      line = 'More investments in Clean200 than Carbon Underground 200'
    } else if (cl_fossil_more_less==='less') {
      line = 'More investments in Carbon Underground 200 than Clean200'
    } else if (cl_fossil_more_less==='same' && cl_asset===0) {
      line = 'No stock investments in Clean200 or Carbon Underground 200'
    } else if (cl_fossil_more_less==='meh' && cl_asset>0) {
      line = 'Same invested in Clean200 as Carbon Underground 200'
    }

    return (
      <div styleName='clean200-subtitle'>
        This fund has:
        <br/>
        <span styleName={'clean200-subtitle-'+cl_fossil_more_less}>
          {line}
        </span>
      </div>
    )
  }

  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false}/>
        </div>
      )
    } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false} />
        </div>
      )
    }

    function getPerc(asset,totalAsset){
      asset = convert.int(asset)
      totalAsset = convert.int(totalAsset)

      if (totalAsset === 0) { return 0 }

      return parseFloat((asset / totalAsset * 100).toFixed(2))
    }

    const { fund, shareClass } = this.props.result
    const { holdings, fundholdings } = fund
    const title = shareClass.fund_legal_name + ' | Clean200 investments'
    const url = config.domain + this.props.location.pathname

    const invested = fund.cl_asset
    const currency = 'USD'
    const percClean200 =  getPerc( fund.cl_asset, fund.fund_net_assets )
    const percFossil =  getPerc( fund.c2asset, fund.fund_net_assets )

    const cl_asset = convert.int(fund.cl_asset)
    const c2asset = convert.int(fund.c2asset)

    const fHoldingsMap = mapFundHoldings(fundholdings)
    const clean200Holdings = filterHoldings(
      fHoldingsMap, holdings, (o) => { return (o.is_cl) }
    )

    const pieChartData = this.getPieChartData(invested, fHoldingsMap,
                                              clean200Holdings)
    const barChartData = this.getBarChartData(percClean200, percFossil)

    const ckLogo = require('../../../static/images/corporate-knights-logo.png')
    const aysLogo = require('../../../static/images/asyousow.png')
    const windImg = require('../../../static/images/windmill.png')
    const solarImg = require('../../../static/images/solar.png')

    const _ticker = shareClass.ticker || null
    let fundName = `${fund.fund_legal_name}`
    fundName = _ticker ? `${fundName} ${_ticker}` : fundName
    const clAsset = convert.int(fund.cl_asset)
    const clWeight = convert.float(fund.cl_weight)
    const _clAsset = format.money(clAsset, true, 'USD', false)
    const _clWeight = format.perc(clWeight)
    const description = `${fundName} has ${_clAsset} invested in Clean200 companies, ${_clWeight} of the fund`

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='fossil-fuel-banner-wrap'>
          <ContainerDivs>
            <h2 styleName='fossil-fuel-banner-hl'>
              <span styleName='fossil-fuel-banner-hl-lg'>Clean200</span>
              <span styleName='fossil-fuel-banner-hl-sm'>200 companies leading on clean energy.</span>
            </h2>
          </ContainerDivs>
        </div>

        <br/>

        { /* FUND MENU COMPONENT */ }
        <FundMenu
          active={'Clean200'}
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
        />

        { /* FUND NAME COMPONENT */ }
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* temporary asset manager letter for Vanguard */ }
        { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }

        <div styleName='main'>
          <div styleName='clean200'>
            <div styleName='clean200-inner'>
              <Row>
                <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>
                  <div styleName='chart'>
                    <Doughnut data={pieChartData} options={pieChartOptions}
                      width='300' height='300' />
                    <div styleName='clean200-chart-details'>
                      <div styleName='clean200-chart-assets'>
                        {format.money(convert.int(invested), true, currency)}
                      </div>
                      <div>invested in Clean200 stocks</div>
                    </div>
                  </div>
                  <div styleName='clean200-stats'>
                    <div styleName='stat' data-multiline={true}
                      data-effect={'solid'} data-for='clean200-tooltip'
                      data-tip={'Total number of Clean200<br/> stock holdings found in this fund'}>
                      <div styleName='stat-count-wrapper'>
                        <div styleName='stat-count'>{ fund.cl_count }</div>
                      </div>
                      <div styleName='stat-label'>
                        Clean200 { (convert.int(fund.cl_count) === 1)
                                   ? ('holding') : ('holdings') }
                      </div>
                    </div>
                    <div styleName='stat' data-multiline={true}
                      data-effect={'solid'} data-for='clean200-tooltip'
                      data-tip={'Total percent of the fund\'s assets<br/>invested in Clean200 stocks'}>
                      <div styleName='stat-count-wrapper'>
                        <div styleName='stat-count'>{ percClean200 }%</div>
                      </div>
                      <div styleName='stat-label'> of assests invested</div>
                    </div>
                  </div>
                  <ReactTooltip id='clean200-tooltip'/>
                  <div styleName='ck-logo-wrap'>
                    <div styleName='ck-label'>
                      Clean200 was created by As&nbsp;You&nbsp;Sow and Corporate&nbsp;Knights
                    </div>
                    <img styleName='ck-ays-logo' src={aysLogo}
                      alt='As You Sow' />
                    <img styleName='ck-logo' src={ckLogo}
                      alt='Corporate Knights' />
                  </div>
                  <div styleName='renewable-img-wrap'>
                    <div styleName='renewable-img-cell'>
                      <img styleName='renewable-img-wind' src={windImg}
                        alt='Wind energy' />
                    </div>
                    <div styleName='renewable-img-cell'>
                      <img styleName='renewable-img-solar' src={solarImg}
                        alt='Solar energy' />
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
                  <div styleName='clean200-info'>
                    The Clean200 is a list of 200 publicly traded companies that are leading the way with solutions for the transition to clean energy. <Link xstrong={true} to={config.links.clean200} title='Carbon Clean 200 - As You Sow'>See the full list<LinkIcon /></Link>
                  </div>
                  { /* render the list of Clean200 holdings */
                    this.renderCompanies(
                      shareClass, fHoldingsMap, 'clean200',
                      'Clean200 holdings', shareClass.cl_count,
                      clean200Holdings, this.state.clean200Page
                    )
                  }
                  <div styleName='clean200-info-large'>Methodology</div>
                  <div styleName='clean200-info-small'>
                    The Clean200 are the largest 200 public companies ranked by green energy revenues. The dataset is developed by multiplying a company’s most recent year-end revenues by its clean revenue estimate, primarily sourced from Corporate Knights Research supplemented by FactSet, Bloomberg BNEF, and FTSE Russell data. In order to be eligible, a company must have USD revenue of at least $1 billion (most recent available fiscal year-end data) and earn more than 10% of total revenues from clean sources, which extends beyond energy efficiency, green energy, and zero emission and hybrid vehicles. We include banks that are financing the low-carbon solutions; real estate companies leading the way on low-carbon buildings; forestry companies protecting carbon sinks; responsible miners of critical materials for the low carbon economy; food and apparel companies with products that are primarily made of raw materials with a significantly lower carbon footprint; and energy-hungry information and communications technology companies that are leading the way on renewable energy. <Link xstrong={true} to={config.routes.clean200} title='Clean200'>More<LinkIcon /></Link>
                  </div>
                  { this.renderMoreLessHeadline(cl_asset, c2asset) }
                  <div styleName='bar-wrap'>
                    <div styleName='bar-wrap-inner'>
                      <Bar data={barChartData} options={barChartOptions}
                        width='300' height='400' />
                    </div>
                  </div>
                </Col>
              </Row>

              <br/>
              <br/>
              <br/>
              <InlineSignup />

            </div>
          </div>
        </div>

        { /* <FundNext prev={'carbon-footprint'} prevLabel={'Carbon footprint'}
          next={'investment-profile'} nextLabel={'Investment profile'}
          ticker={shareClass.ticker} name={shareClass.fund_legal_name}
          investmentVehicleId={shareClass.investment_vehicle_id}
          fundId={shareClass.fund_id} /> */ }

        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />

        { /* FUND TAKE ACTIONS COMPONENT */ }
        { /*
        <FundShareTakeAction shareClass={shareClass} url={url}/>
        */ }

      </div>
    )
  }
}
